import React from "react";
import PageWithConfigurator from "../../shared/pageWithConfigurator/pageWithConfigurator";

import TotalRevenueSalesModule from "./totalRevenueSales/index";
import ServiceSalesModule from "./serviceSales/index";
import ProductSalesModule from "./productSales/index";
import PastDuePerformance from "./pastDuesPerformance/index";
import DiscountsModule from "./discounts/index";
import AIAgent from "..//ai";

const pageConfig = {
  pageName: "Sales Revenue",
  configuratorWidth: { dark: 400, light: 350 },
  moduleList: [
    TotalRevenueSalesModule,
    ServiceSalesModule,
    ProductSalesModule,
    PastDuePerformance,
    DiscountsModule
  ]
};

const SalesRevenuePage = ({ notifications, objectId }) => (
  <PageWithConfigurator
    pageConfig={pageConfig}
    notifications={notifications}
    renderAI={() => <AIAgent pageName="sales_revenue" widget objectId={objectId} />}
  />
);

export default SalesRevenuePage;
